/* eslint-disable react-hooks/exhaustive-deps */
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Layout, Text } from 'components/styleguide';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { uploadTracksImportFileCall } from 'redux-core/import-tracks-spreadsheet/actions';

const ACCEPTED_FORMATS = '.xlsx';
const rootT = 'drawers.importTracksSpreadsheetDrawer';

const FileDropZone = ({
  setS3FileKey,
}) => {
  const useOnDrop = () => useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    const key = await uploadTracksImportFileCall(
      file, { kind: file.type },
    );

    if (key) {
      setS3FileKey(key);
    }
  });

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: useOnDrop(),
    accept: ACCEPTED_FORMATS,
    maxFiles: 1,
  });

  return (
    <Layout width="auto" height="auto" p={1} container>
      <Grid item container>
        <Box height="100vh" width={1}>
          <div style={{
            display: 'flex',
            height: '55%',
            padding: '20px',
          }}
          >
            <div
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...getRootProps()}
              style={{
                width: '100%',
                height: '100%',
                border: '1px dashed #cccccc',
                borderRadius: '4px',
                padding: '20px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <input {...getInputProps()} />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '42px',
                  height: '42px',
                  borderRadius: '100%',
                  backgroundColor: '#d9d9d9',
                }}
                >
                  <UploadFileIcon style={{ color: '#282078' }} />
                </div>
                <Trans
                  i18nKey={`${rootT}.dropZone.clickOrDragDrop`}
                >
                  <div>
                    <Typography
                      variant="caption"
                      sx={{
                        textDecoration: 'underline',
                        color: 'primary.main',
                        cursor: 'pointer',
                      }}
                    />
                    <Typography
                      variant="caption"
                    />
                  </div>
                </Trans>
                <Trans
                  i18nKey={`${rootT}.dropZone.maxSize`}
                  values={{
                    size: 3,
                  }}
                >
                  <Text variant="formLabel" />
                </Trans>
              </div>
            </div>
          </div>
        </Box>
      </Grid>
    </Layout>
  );
};

export default FileDropZone;
